module.exports = __webpack_public_path__ + "img/1480119568.bb6cb5a2.jpg";